<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">SupplierSites</h2>
      <div class="flex gap-2">
        <p-button
          label="New SupplierSite"
          icon="pi pi-plus"
          (onClick)="createSupplierSite()"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-truck"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="supplierSiteName" id="supplierSiteNameFilter" class="w-full" />
                <label for="supplierSiteNameFilter">Supplier Site Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="supplierSiteNumber" id="supplierSiteNumberFilter" class="w-full" />
                <label for="supplierSiteNumberFilter">Supplier Site Code</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button" (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table
      #dt
      [value]="supplierSites"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadSupplierSite($event)"
      dataKey="id"
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="supplierSiteName">
            Supplier Site Name
            <p-sortIcon field="supplierSiteName"></p-sortIcon>
          </th>
          <th pSortableColumn="supplierSiteCode">
            Supplier Site Code
            <p-sortIcon field="supplierSiteCode"></p-sortIcon>
          </th>
          <th style="width: 10rem">Actions</th>
        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-supplierSite>
        <tr>
          <td>{{ supplierSite.supplierSiteName }}</td>
          <td>{{ supplierSite.supplierSiteNumber ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editSupplierSite(supplierSite.supplierSiteId)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteSupplierSite(supplierSite)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Supplier Site found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
